import React, { ComponentProps } from 'react';
import { Delta } from '@usepepper/sprout-kit-ui';
import { toFixedDecimalPercentage } from '@/utils/percentage';

interface MetricDeltaProps {
  changePercentage: number | null;
  size?: ComponentProps<typeof Delta>['size'];
}

export const MetricDelta: React.FC<MetricDeltaProps> = ({
  changePercentage,
  size = '$sm',
}) => {
  if (changePercentage === null) {
    return null;
  }

  return (
    <Delta
      direction={changePercentage >= 0 ? 'up' : 'down'}
      size={size}
      value={toFixedDecimalPercentage(Math.abs(changePercentage))}
    />
  );
};
